<script>
import wx from 'weixin-js-sdk';
import {
  consumablesOrderWareHousekeeperList,
  consumablesOrderSortRelation,
  consumablesBranchOrderInfoId, consumablesOrderSortRelationList
} from "@/lib/request";
import {getLocalItem} from "@/untils/common";
import {Dialog} from "vant";
export default {
  name: 'consume',
  data(){
    return{
      latitude:'',
      longitude:'',
      activeTab: '1',
      siteId:'',
      warehouseNameStr:'',
      // 列表数据
      page1:1,//当前页
      size1:20,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      orderList:[],
      lastFlag:false,
      lastObj:{},
      lastList:[],
      lastType:''
    }
  },
  watch:{
    // 监控参数变化
    listParams:function() {
      if(this.siteId&&this.siteId.length>=8){
        this.getList();
      }else{
        if(this.siteId.length>0&&this.siteId.length<8){

        }else{
          this.getList();
        }
      }

    },
  },
  computed:{
    // 监控参数变化更新
    listParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        warehouseName:this.warehouseNameStr,
        branchId:this.siteId.length>=8?this.siteId:'',
        //   <=1:申领记录0-3
        //   >=4:出库记录4-7
        //   状态，-1:处理中、0:待出库、 1:正在出库、 2:配送中、3:待提取、4:配送完成、5:已提取、6:取消、7:失败
        status:this.activeTab==='1'?0:4,
        endStatus:this.activeTab==='1'?3:7,
        orderByColumn:'createTime',
        isAsc:'desc',//desc:降序，asc:升序
      };
    },
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if(this.page1<this.totalPages1){
          this.page1 = this.page1+1;
        }
      },1000);
    },

    getTabVan(){
      this.page1 = 1;
      this.getList();
    },
    // 首次进来系统时，调签名接口，此时的调用是再出发微信扫一扫失败时，调用一下签名接口
    getConfig(item) {
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'getLocation',
                  'scanQRCode',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                console.log('wx.ready----')
                this.getScanModal(item)
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },
    getListForm(){
      console.log(this.lastType)

    },
    getLastModal(item,type){
      consumablesOrderSortRelationList({
        orderId:item.orderId
      }).then((res)=>{
        if(res){
          if(res.data){
            this.lastFlag = true;
            this.lastObj = item;
            this.lastType = type;
            if(res.data.rows.length>0){
              this.lastList = res.data.rows;
            }else{
              this.lastList = [];
            }
          }
        }
      });
    },
    // 出库
    getScanModal(item){
      let that = this;
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
        isHighAccuracy: true,
        success: data=> {
          console.log(data,'getLocation');
          that.latitude = data.latitude;
          that.longitude = data.longitude;
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            zoom: 3,                      // 放大倍数(1-10)
            focus: true,                  // 启用自动对焦
            autoZoom: true,               // 启用自动缩放(微信7.0.12+)
            inverse: true,                // 尝试识别反色条码
            success: res => {
              if (res && res.resultStr) {
                console.log(res)
                let codeStr = res.resultStr.split(',');
                if(codeStr[1]&&(codeStr[1].length>10&&codeStr[1].length<13)){
                  if(codeStr[1].substring(0,1)!=='F'){
                    that.$toast('请选择正确的箱号对应的条形码！')
                    return false;
                  }
                  // ||codeStr[1].substring(0,2)!=='FI'
                  let params = {
                    "orderId": item.orderId,
                    "whId": item.whId,
                    "barcode":codeStr[1],
                    "longitude":that.longitude,
                    "latitude":that.latitude,
                  };
                  console.log(params)
                  consumablesOrderSortRelation(params).then((response) => {
                    if (response) {
                      let res = response.data;
                      if (res.code) {
                        if (res.code === 200) {
                          consumablesBranchOrderInfoId({
                            orderId:item.orderId
                          }).then((resp) => {
                            let res = resp.data;
                            if (res) {
                              if (res.code && res.code === 200) {
                                if(res.data.status===1){
                                  Dialog.alert({
                                    title: '提示',
                                    message: `预计还有1箱，继续扫描`,
                                    confirmButtonText: '出库',
                                    theme: 'round-button',
                                  }).then(() => {
                                    that.getScanModal(item);
                                  });
                                } else {
                                  that.$toast('提交成功！');
                                  that.getLastModal(item,'yes');
                                  that.page1 = 1;
                                  that.getList();
                                }
                              } else {
                                if (res.msg) {
                                  that.$toast(res.msg);
                                }
                              }
                            }
                          });
                        } else {
                          that.page1 = 1;
                          that.getList();
                          that.getLastModal(item,'no');
                        }
                      } else {
                        if (res.msg) {
                          that.$toast(res.msg);
                        }
                      }
                    }
                  });
                }else{
                  that.$toast('请选择正确的箱号对应的条形码！')
                  return false;
                }
              }
            },
            fail: err => {
              that.getConfig(item);
              console.error(err);
              console.error(err.errMsg);
            }
          });
        },
        fail: err => {
          console.log('wx.getLocation方法 ，失败');
          console.log(err);
          console.log(err.errMsg);
          that.getConfig(item);
          if (err.errMsg.includes('user deny')) {
            that.$toast('您拒绝了位置授权，请前往设置开启');
          } else {
            that.$toast(`获取位置失败：${err.errMsg}`);
          }
        }
      });
    },
    getList() {
      this.loading1 = true;
      this.finished1 = false;
      if (this.listParams.pageNum === 1) {
        this.orderList = [];
      }
      consumablesOrderWareHousekeeperList(this.listParams).then((res) => {
        if (res) {
          if (!res.data) {
            return;
          }
          if (res.data) {
            this.loading1 = false;
            if (res.data.code === 200) {
              this.totals1 = res.data.total;
              this.totalPages1 = Math.ceil(res.data.total / this.size1);
              if (res.data.rows == null || res.data.rows.length === 0) {
                this.finished1 = true;
                this.orderList = [];
                return false;
              } else {
                if (this.page1 > 1) {
                  this.orderList = this.orderList.concat(res.data.rows);
                } else {
                  this.orderList = res.data.rows;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    }
  },
  created() {
    if (getLocalItem('deptName')) {
      if (getLocalItem('deptName').split('-') && getLocalItem('deptName').split('-').length > 0) {
        if (getLocalItem('deptName').split('-')[1]) {
          this.warehouseNameStr = getLocalItem('deptName').split('-')[1].substring(0, 2);
        } else {
          this.warehouseNameStr = getLocalItem('deptName');
        }
      }
    }
  }
}
</script>

<template>
  <div class="content-inn">
    <van-popup
        v-model="lastFlag"
        round
        closeable
        :close-on-click-overlay="false"
        close-icon-position="top-right"
        position="center"
        :style="{ width:'90%' }"
        @close="getListForm"
    >
      <div class="logs-inner">
        <div class="logs-inner-head">
          箱号信息
        </div>
        <div class="logs-inner-title">
          <div class="con-sum-list" v-for="(item,index) in lastList" :key="index">
            <div class="logistics-number">
              <div class="lg-label">箱号:</div>
              <div class="lg-content">{{item.barcode}}</div>
            </div>
            <div class="logistics-number">
              <div class="lg-label">网点编号:</div>
              <div class="lg-content">{{item.branchId}}</div>
            </div>
            <div class="logistics-number">
              <div class="lg-label">操作员:</div>
              <div class="lg-content">{{item.nickName}}</div>
            </div>
            <div class="logistics-number" v-if="item.outboundTime&&item.status>0">
              <div class="lg-label">出库时间:</div>
              <div class="lg-content">{{item.outboundTime}}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="tabs">
      <van-tabs v-model="activeTab" animated swipeable sticky @click="getTabVan">
        <van-tab title="申请记录" name="1"></van-tab>
        <van-tab title="出库记录" name="4"></van-tab>
      </van-tabs>
    </div>
    <div class="nav-search">
      <input type="number" v-model="siteId" placeholder="输入8位网点编号自动搜索"/>
      <button class="button" @click="siteId=''">重置</button>
    </div>
    <div class="tab-content">
      <div class="record-content">
        <!-- 列表 -->
        <div class="application-content">
          <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"
                    @load="onLoad">
            <div class="application-item" v-for="(item,index) in orderList" :key="index">
              <div class="application-info-wrapper">
                <div class="application-header">
                  <span class="application-id">网点编号: {{ item.branchId }}</span>
                </div>
                <div class="application-details">
                  <div class="detail-item">
                    <span class="box-detail-label">仓库:</span>
                    <span class="detail-value network-code">{{ item.warehouseName }}</span>
                  </div>
                </div>
                <!--                <div class="application-details">-->
                <!--                  <div class="detail-item">-->
                <!--                    <span class="box-detail-label">网点编号:</span>-->
                <!--                    <span class="detail-value network-code">{{ item.branchId }}</span>-->
                <!--                  </div>-->
                <!--                </div>-->
                <div class="application-details">
                  <div class="detail-item">
                    <span class="box-detail-label">申请数量:</span>
                    <span class="detail-value quantity-highlight">{{ item.boxNumber }}箱</span>
                  </div>
                </div>
                <div class="application-details">
                  <div class="detail-item">
                    <span class="box-detail-label">申领时间:</span>
                    <span class="detail-value">{{ item.createTime }}</span>
                  </div>
                </div>
                <div class="application-details">
                  <div class="detail-item">
                    <span class="box-detail-label">领取方式:</span>
                    <span class="detail-value">{{ item.distributionType === 1 ? '自取' : '配送' }}</span>
                  </div>
                </div>
                <div class="application-details">
                  <div class="detail-item">
                    <span class="box-detail-label">订单状态:</span>
                    <span class="detail-value">
                      {{ item.status === -1 ? '处理中' : '' }}
                      {{ item.status === 0 ? '待出库' : '' }}
                      {{ item.status === 1 ? '正在出库' : '' }}
                      {{ item.status === 2 ? '配送中' : '' }}
                      {{ item.status === 3 ? '待提取' : '' }}
                      {{ item.status === 4 ? '配送完成' : '' }}
                      {{ item.status === 5 ? '已提取' : '' }}
                      {{ item.status === 6 ? '取消' : '' }}
                      {{ item.status === 7 ? '失败' : '' }}
                    </span>
                  </div>
                </div>
                <div class="application-details" v-if="item.nickName">
                  <div class="detail-item">
                    <span class="box-detail-label">操作员:</span>
                    <span class="detail-value">{{ item.nickName }}</span>
                  </div>
                </div>
                <div class="application-details" v-if="item.outboundTime&&item.status>0">
                  <div class="detail-item">
                    <span class="box-detail-label">出库时间:</span>
                    <span class="detail-value">{{ item.outboundTime }}</span>
                  </div>
                </div>
              </div>
              <div class="action-buttons" v-if="item.status<4">
                <img src="@/assets/images/code.gif" alt="" />
                <span class="action-btn outbound-btn" @click="getScanModal(item)">扫描条形码</span>
              </div>
              <div class="action-buttons" v-else>
                <span class="sp-act" @click="getLastModal(item,'no')">
                    查看
                  </span>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-inn {
  padding-top: 90px;
}

.logs-inner{
  padding:0 20px 30px;
  .logs-inner-head{
    padding: 30px  ;
    font-weight: bold;
    font-size: 34px;
    text-align: center;
  }
  .con-sum-list{
    border-radius: 10px;
    box-shadow:2px 3px 20px 5px rgba(2, 2, 2, 0.2);
    margin-bottom: 30px;
  }
}
.hg{
  min-height: 60px;
  line-height: 60px;
}
.logistics-number{
  padding:10px 20px;
  box-sizing: border-box;
  .lg-label{
    display: inline-block;
    vertical-align: top;
  }
  .lg-content{
    display: inline-block;
    word-wrap:break-word;
    white-space: normal;
  }
  .num-order{
    color: #03A9F4;
    vertical-align: top;
  }
  .copy-button{
    display: inline-block;
    background-color: #E1F5FE;
    color: #03A9F4;
    height: 40px;
    line-height: 40px;
    padding:0 10px;
    box-sizing: border-box;
    border: none;
    outline: none;
    border-radius:8px;
    margin-left: 6px;
  }
}
.nav-search {
  display: flex;
  flex-direction: row;
  padding: 0 30px 10px;

  input {
    width: 78%;
    height: 80px;
    outline: none;
    padding: 0 20px;
    box-sizing: border-box;
    border-radius: 5px;
    border: 2px solid #ddd;
    margin-right: 2%;
  }

  .button {
    width: 20%;
    border-radius: 5px;
    height: 78px;
    font-size: 28px;
    background: #e62d2d;
    color: #fff;
    border: none;
  }
}

.prediction-notice {
  background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
  color: white;
  padding: 20px 20px;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  border-bottom: 1px solid #e9ecef;
}

.van-cell {
  border: 2px solid #e9ecef;
  border-radius: 10px;
}

.form-section {
  padding: 20px;
}

.modal-options {
  padding: 0 30px;
  display: flex;
  flex-wrap: wrap;
}

.modal-option {
  background-color: #f5f5f5;
  border-radius: 35px;
  padding: 5px 35px;
  margin-right: 25px;
  margin-bottom: 20px;
  color: #666;
  border: 2px solid #8f8f8f;
}

.active {
  background-color: #e62d2d;
  border: 2px solid #e62d2d;
  color: white;
}

.record-time {
  color: #6c757d;
  background: #f8f9fa;
  padding: 8px 20px;
  border-radius: 22px;
}

.application-content {
  padding: 20px;
}

.application-item {
  background: white;
  border-radius: 12px;
  padding: 20px 15px;
  margin-bottom: 15px;
  //border-left: 4px solid #00b894;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  //align-items: center;

}

.application-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* --- ADDED --- */
.application-info-wrapper {
  margin-right: 5px;
}

.application-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* MODIFIED */
}

.application-id {
  font-size: 28px;
  color: #495057;
  font-weight: 600;
}

.application-details {
  /* --- MODIFICATION START --- */
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px; /* row-gap column-gap */
  /* --- MODIFICATION END --- */
  font-size: 24px;
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 0; /* MODIFIED */
}

.detail-item {
  display: flex;
  /* --- REMOVED justify-content: space-between; --- */
  gap: 5px; /* ADDED */
}

.box-detail-label {
  color: #6c757d;
}

.detail-value {
  color: #2d3436;
}

.quantity-highlight {
  color: #e17055;
  font-weight: 700;
  font-size: 28px;
}

.network-code {
  color: #0984e3;
}

.action-buttons {
  text-align: right;
  flex-shrink: 0;
  width: 35%;
  img{
    display: flex;
    justify-content: center;
    flex: 1;
    width: 100%;
    margin: 0 auto 10px;
  }
  .sp-act{
    display: inline-block;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 20px 0;
    width: 120px;
    text-align: center;
  }
}

.action-btn {
  padding: 14px 26px;
  border: none;
  border-radius: 6px;
  font-size: 28px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.outbound-btn {
  background: linear-gradient(135deg, #e17055 0%, #d63031 100%);
  color: white;
}

.outbound-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.3);
}

.outbound-btn:disabled {
  background: #bbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
</style>